/**
 * Logging helper functions
 */
export const logError = (req, message, context = {}) => {
  req.log.error({ message, context });
};

export const logInfo = (req, message, context = {}) => {
  req.log.info({ message, context });
};

export const logWarn = (req, message, context = {}) => {
  req.log.warn({ message, context });
};
